'use client';

import dynamic from 'next/dynamic';

//* Components
import Page from '@/components/global/Page';
import HeroSection from '@/components/sections/HeroSection';

const MouseHoverSection = dynamic(() => import('@/components/sections/MouseHoverSection'), { ssr: false });
const TeamMembers = dynamic(() => import('./components/TeamMembers'), { ssr: false })
const GallerySection = dynamic(() => import('@/components/sections/GallerySection'), { ssr: false });
const GetItTouchSection = dynamic(() => import('@/components/sections/GetItTouchSection'), { ssr: false });

//* Style
import TeamPageStyle from '@/styles/pages/TeamPageStyle';

export default function TeamTemplate({ pageData }) {
    return (
        <Page className={'team'}>
            <TeamPageStyle>
                <HeroSection {...pageData.data.hero} />

                <MouseHoverSection
                    isMoueAnim={false}
                    {...pageData.data.info}
                />

                <TeamMembers data={pageData.data.team_members} />

                <GallerySection {...pageData.data.certificate} />

                <GetItTouchSection />
            </TeamPageStyle>
        </Page>
    );
}
